import { DollarCircleOutlined } from '@ant-design/icons';
import { Tabs } from 'antd';
import { useState } from 'react';
import { T } from 'react-translator-component';

import { Div, Title } from './styled';

import FinancialTable from '../../organisms/FinancialTable/FinancialTable';
import { TabType } from '../../organisms/FinancialTable/useFinancialTable';
import { hasReconciliationRole } from '../../../utils/hasReconciliationRole/hasReconciliationRole';
import ReconciliationHistoryPage from '../ReconciliationHistoryPage';

const HISTORY_KEY = 'reconciliationHistory';

const FinancialList = () => {
  // activeKey controlado pra ReconciliationHistoryPage detectar quando a aba
  // volta a ficar visível e re-executar o fetch (antd Tabs mantém TabPane
  // montada por default, então o useEffect [] inicial só dispara 1 vez).
  const [activeKey, setActiveKey] = useState<string>(TabType.ALLMOVEMENTS);

  return (
    <Div>
      <Title>
        <DollarCircleOutlined style={{ marginRight: 16 }} />
        {T('Financial')}
      </Title>

      <Tabs activeKey={activeKey} onChange={setActiveKey}>
        <Tabs.TabPane tab={T('All transactions')} key={TabType.ALLMOVEMENTS}>
          <FinancialTable tab={TabType.ALLMOVEMENTS} />
        </Tabs.TabPane>

        <Tabs.TabPane tab={T('Recharges')} key={TabType.RECHARGES}>
          <FinancialTable tab={TabType.RECHARGES} />
        </Tabs.TabPane>

        <Tabs.TabPane tab={T('Deposits')} key={TabType.DEPOSITS}>
          <FinancialTable tab={TabType.DEPOSITS} />
        </Tabs.TabPane>

        {hasReconciliationRole() && (
          <Tabs.TabPane tab='Histórico de conciliações' key={HISTORY_KEY}>
            <ReconciliationHistoryPage isActive={activeKey === HISTORY_KEY} />
          </Tabs.TabPane>
        )}
      </Tabs>
    </Div>
  );
};

export default FinancialList;
